import { ReactNode } from "react";
import cn from "classnames";

import { Header, HeaderProps, Footer } from "@/basic/components";
import styles from "./styles.module.scss";

export interface StickyLayoutProps extends HeaderProps {
  children: ReactNode;
  className?: string;
  noSpacing?: boolean;
  testId?: string;
}

export const StickyLayout = ({ children, logoAlignment, testId, className, noSpacing }: StickyLayoutProps) => {
  const stickyLayoutClass = cn(
    styles["StickyLayoutWrapper"],
    { [styles["noSpacing"]]: noSpacing },
    className,
  );

  return (
    <>
      <Header logoAlignment={logoAlignment} noSpacing={noSpacing} />
      <main className={stickyLayoutClass} data-testid={testId ? testId : undefined}>
        {children}
      </main>
      <Footer />
    </>
  );
};
